import React from 'react'
import { useState } from 'react';
import ReactModal from 'react-modal'
import ProfessionalDetailsSubModal from 'Modals/ProfessionalDetailsSubModal';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';
import useIsMobile from 'Hooks/useIsMobile';

function ProfessionalDetailsModal({showModalProf, setShowModalProf, setUpdateComp, contentStep, onClose, professionalDetails, startIndex, caseDetails}) {

    const [page,setPage] = useState(startIndex ? startIndex : 0);
    const isMobile =useIsMobile();
    const count = professionalDetails?.length - 1;
    const subTitle = () => {
      switch(contentStep) {
          case 2:
              return "New Requests to view the case";
          case 3:
              return "Conflict check in progress";
          case 4:
            return "Legal Professionals who are reviewing the case";
          case 5:
            return "Have you signed the contract with this professional ?";
          default:
              return "Tile goes here";
    }}
  return (
    <ReactModal
    shouldCloseOnEsc = {true}
    shouldCloseOnOverlayClick = {true}
    onRequestClose={onClose}
    isOpen = {showModalProf}
    style={{
        overlay: {
          // above the sticky case header (z-50) so the title + close button aren't covered
          zIndex: 60,
          backgroundColor: 'rgba(20,33,61,.45)'
        },
        content: isMobile ? {
            // phones: bottom sheet, full width, actions stay pinned at the bottom
            top: 'auto', left: 0, right: 0, bottom: 0,
            width: '100%', maxWidth: '100%',
            height: 'auto', maxHeight: '90vh', overflowY: 'auto',
            padding: '16px 16px 0',
            border: 'none',
            borderRadius: '16px 16px 0 0',
            backgroundColor: '#fffdf8',
            boxShadow: '0 -12px 32px rgba(20,33,61,.3)',
            zIndex: 60,
        } : {
            height: 'auto',
            maxHeight: '88vh',
            overflowY: 'auto',
            padding: '22px',
            width: '540px',
            maxWidth: '92vw',
            minHeight: '400px',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 60,
            border: '1px solid rgba(20,33,61,.14)',
            borderRadius: '14px',
            backgroundColor: '#fffdf8',
            boxShadow: '0 12px 32px rgba(20,33,61,.3)',
        }
      }}
    >
        <div className='flex flex-col w-full font-plexsans'>

            {isMobile && <div className='mx-auto mb-3 w-9 h-1 rounded-full bg-[rgba(20,33,61,.18)]' />}
            <div className='flex items-start justify-between gap-4 mb-4'>
                <div className='min-w-0'>
                    <div className='text-[13.5px] font-semibold leading-snug text-navy'>{subTitle()}</div>
                    {isMobile && count > 0 &&
                        <div className='flex items-center gap-2 mt-2'>
                            <button type="button" disabled={page === 0} onClick={() => setPage((prev) => prev - 1)}
                            className={'w-7 h-7 rounded-full border flex items-center justify-center ' + (page === 0 ? 'border-[rgba(20,33,61,.1)] text-[rgba(20,33,61,.25)]' : 'border-[rgba(20,33,61,.2)] text-navy')}><ChevronLeft size={14}/></button>
                            <span className='text-[12px] text-[rgba(20,33,61,.55)]'>{page + 1} of {count + 1}</span>
                            <button type="button" disabled={page >= count} onClick={() => setPage((prev) => prev + 1)}
                            className={'w-7 h-7 rounded-full border flex items-center justify-center ' + (page >= count ? 'border-[rgba(20,33,61,.1)] text-[rgba(20,33,61,.25)]' : 'border-[rgba(20,33,61,.2)] text-navy')}><ChevronRight size={14}/></button>
                        </div>}
                </div>
                <button type="button" onClick={onClose} className='flex-none text-[rgba(20,33,61,.4)] hover:text-navy transition-colors cursor-pointer bg-transparent border-none p-1 -mt-1 -mr-1'>
                    <X size={18}/>
                </button>
            </div>

            <div className='flex items-start w-full gap-2.5'>
               {count > 0 && !isMobile &&
                <button
                type="button"
                disabled={page === 0}
                onClick={() => setPage((prev) => prev - 1)}
                className={'flex-none w-8 h-8 mt-1 rounded-full border flex items-center justify-center transition-colors ' + (page === 0 ? 'border-[rgba(20,33,61,.1)] text-[rgba(20,33,61,.25)] cursor-not-allowed' : 'border-[rgba(20,33,61,.18)] text-navy hover:border-tan hover:text-tan cursor-pointer')}
                ><ChevronLeft size={16}/></button>
                }
                <div className='w-full min-w-0'>
                  {professionalDetails[page]?.userId?._id !== undefined ?
                  <ProfessionalDetailsSubModal
                  inSheet={isMobile}
                  professionalDetails={professionalDetails[page]}
                  contentStep={contentStep}
                  setShowModalProf={setShowModalProf}
                  setUpdateComp={setUpdateComp}
                  caseDetails={caseDetails}
                  />
                  :
                  <div className='text-center text-[13px] text-[rgba(20,33,61,.5)] py-12'>User details not found. This happens when the user changes firms</div>
                  }
                </div>
                {count > 0 && !isMobile &&
                <button
                type="button"
                disabled={page >= count}
                onClick={() => setPage((prev) => prev + 1)}
                className={'flex-none w-8 h-8 mt-1 rounded-full border flex items-center justify-center transition-colors ' + (page >= count ? 'border-[rgba(20,33,61,.1)] text-[rgba(20,33,61,.25)] cursor-not-allowed' : 'border-[rgba(20,33,61,.18)] text-navy hover:border-tan hover:text-tan cursor-pointer')}
                ><ChevronRight size={16}/></button>
                }
               </div>
               {isMobile && <div className='h-4 flex-none' />}
        </div>
    </ReactModal>
  )
}

export default ProfessionalDetailsModal;
